import React from 'react'
import { useEffect } from 'react'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import CardProject from '../molecules/CardProject'
import Contact from '../organims/Contact'

const Home=(props)=>{
  const skillsn=[1,2,3]
  const skillstoolsn=[1,2,3,4,5,6]
  let removeItemFromArr = ( arr, item ) => {
    let i = arr.indexOf( item );
    i !== -1 && arr.splice( i, 1 );
  };

  let listProjects=[]
  let listRecent=[]
  if (props.data){
    props.data.skills.forEach(s=>{
      listProjects.push(...s.projects.map(p=>(p)))
    })
    // // let na=listProjects.length-3
    for (let i = 0; i < 3; i++) {
      let a=Math.max(...listProjects.map(l=>(l.id)))
      listRecent.push(listProjects.find(l=>(l.id===a)))
      removeItemFromArr(listProjects,listProjects.find(l=>(l.id===a)))
    }
  }

  useEffect(()=>{
    document.documentElement.scrollTop=0
    document.querySelector('.images').classList.add('carged')
    document.querySelector('.about-description').classList.add('carged')
  },[])

    return (
      <>
      <div className="about-me">
      <div className="images">
        <div className="tools">
          <img src="media/graphs/tools.svg" alt="herramientas-imagen"/>
        </div>
        <div className="man-pc">
          <img src="media/graphs/hacker.svg" alt="hacker"/>
        </div>
      </div>
      <div className='about-description'>
        <p className='about-text'>Hola! Soy Luis Felipa Delgado, soy un estudiante autodidacta y apasionado por la tecnologia y el mundo moderno. <br />Paso la mayor parte del tiempo aprendiendo sobre las tecnologias actuales, por lo que tengo conocimientos claros en Desarollo Web, Programación , Diseño de interfaces y Edicion audiovisual.</p>
        <div className="button">
          <NavLink to='/contacto'>Conoce mas...</NavLink>
        </div>
      </div>
    </div>
    <div id='skills' className="skills">
      <h1 className="title">Habilidades</h1>
      <div className="skills-container">
      {
        props.data
        ?props.data.skills.map(s=>(
          <div key={s.name} className="container-skills">
            <h2>{s.name}</h2>
            <div className="line"></div>
              <div className="skills-tools">
                {
                  s.tools.map(t=>(
                    <div key={t.name} className="tool-item">
                      <div className="tool-image-container"><img src={t.image} alt={t.name} className="tool-image"/>
                      </div>
                      <p className="tool-name">{t.name}</p>
                      <div className={`tool-points n${t.points}`}>
                        <div className="point"></div>
                        <div className="point"></div>
                        <div className="point"></div>
                        <div className="point"></div>
                        <div className="point"></div>
                      </div>
                    </div>
                  ))
                }
                </div>
          </div>
        ))
        : skillsn.map(s=>(
          <div key={s} className="container-skills">
            <p className='h2 ske'/>
            <div className="line"></div>
            <div className="skills-tools">
              {
                skillstoolsn.map(t=>(
                  <div key={t} className="tool-item">
                    <div className="tool-image-container ske">
                      <p className="tool-image"/>
                    </div>
                    <p className="tool-name ske"></p>
                    <div className='tool-points ske'>
                      <div className="point"></div>
                      <div className="point"></div>
                      <div className="point"></div>
                      <div className="point"></div>
                      <div className="point"></div>
                    </div>
                  </div>
                ))
              }
            </div>
          </div>
        ))
      }
      </div>
    </div>
    <div className="recent-projects">
      <h1>Ultimos proyectos</h1>
      {
        listRecent && listRecent[0] && listRecent[1] && listRecent[2]
        ?<>
          <div className="project-container">
            <div className="graph-container"><img src="/media/graphs/webDev.svg" alt="desarollador" className="graph-image"/></div>
            <CardProject video={listRecent[0].video} id={listRecent[0].id} images={listRecent[0].images} image={listRecent[0].images[0]} longDescription={listRecent[0].longDescription} url={listRecent[0].url} description={listRecent[0].shortDescription} tools={listRecent[0].tools}/>
          </div>
          <div className="project-container">
            <div className="graph-container"><img src="/media/graphs/manageProject.svg" alt="ideas proyecto" className="graph-image"/></div>
            <CardProject video={listRecent[1].video} id={listRecent[1].id} images={listRecent[1].images} image={listRecent[1].images[0]} longDescription={listRecent[1].longDescription} url={listRecent[1].url} description={listRecent[1].shortDescription} tools={listRecent[1].tools}/>
          </div>
          <div className="project-container">
            <div className="graph-container"><img src="/media/graphs/menUp.svg" alt="subida de bolsa" className="graph-image"/></div>
            <CardProject video={listRecent[2].video} id={listRecent[2].id} images={listRecent[2].images} image={listRecent[2].images[0]} longDescription={listRecent[2].longDescription} url={listRecent[2].url} description={listRecent[2].shortDescription} tools={listRecent[2].tools}/>
          </div>
        </>
        :<>
        <div className="project-container">
          <div className="graph-container"><img src="/media/graphs/webDev.svg" alt="desarollador" className="graph-image"/></div>
          <div className="card-project ske"></div>
        </div>
        <div className="project-container">
          <div className="graph-container"><img src="/media/graphs/manageProject.svg" alt="ideas proyecto" className="graph-image"/></div>
          <div className="card-project ske"></div>
        </div>
        <div className="project-container">
          <div className="graph-container"><img src="/media/graphs/menUp.svg" alt="subida de bolsa" className="graph-image"/></div>
          <div className="card-project ske"></div>
        </div>
      </>
      }
      </div>
    <Contact/>
    </>
    )
  }

const mapStateToProps=(state)=>(
  {
    data:state.data
  }
)

export default connect(mapStateToProps,{})(Home)
